import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "list-group list-group-flush list-group-form-fieldset-nav sticky-below-page-form-nav d-none" }
const _hoisted_2 = {
  href: "#",
  class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center active",
  "aria-current": "true"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" The current link item ")
const _hoisted_4 = {
  href: "#",
  class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" A second link item ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center"
}, " A third link item ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center"
}, " A fourth link item ", -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "text-muted small mt-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "table table-hover border-top border-black-10" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  class: "btn btn-primary",
  type: "button",
  disabled: ""
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-4" }
const _hoisted_21 = {
  class: "btn btn-secondary",
  type: "submit"
}
const _hoisted_22 = { class: "col-8 text-end" }
const _hoisted_23 = {
  key: 2,
  class: "card mb-2"
}
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = {
  href: "/files/Statistik_Wissenschaft_Vorlage für Portal.xlsx",
  target: "_blank",
  download: "Statistik_Wissenschaft_Vorlage für Portal.xlsx"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col mb-2" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "table table-hover border-top border-black-10" }
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "text-end" }
const _hoisted_37 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_SubHeader = _resolveComponent("SubHeader")!
  const _component_SVGCheck = _resolveComponent("SVGCheck")!
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_MainFormBottomBar = _resolveComponent("MainFormBottomBar")!
  const _component_FormRenderComponent = _resolveComponent("FormRenderComponent")!
  const _component_ProgressWheel = _resolveComponent("ProgressWheel")!
  const _component_b_icon_file_earmark_arrow_down = _resolveComponent("b-icon-file-earmark-arrow-down")!
  const _component_ApplicationFormFileUpload = _resolveComponent("ApplicationFormFileUpload")!
  const _component_MainFormContainer = _resolveComponent("MainFormContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, { position: "" }),
    (_ctx.isLoaded)
      ? (_openBlock(), _createBlock(_component_SubHeader, {
          key: 0,
          "link-to-overview": `/application/${_ctx.applicationForm.application}`
        }, null, 8, ["link-to-overview"]))
      : _createCommentVNode("", true),
    (_ctx.isLoaded)
      ? (_openBlock(), _createBlock(_component_MainFormContainer, {
          key: 1,
          title: _ctx.$t(_ctx.getFormTitle(_ctx.applicationForm.form_type)),
          "is-json-form": ""
        }, {
          "form-fieldsets-nav": _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("a", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_SVGCheck, { class: "ms-2" })
              ]),
              _createElementVNode("a", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_SVGCheck, { class: "ms-2" })
              ]),
              _hoisted_6,
              _hoisted_7
            ])
          ]),
          form: _withCtx(() => [
            _createVNode(_component_Alerts, { sticky: "sticky-below-page-form-nav" }),
            (_ctx.applicationForm.form_type === _ctx.FormType.FormTypeGeneralInformation &&
         !_ctx.application.organization.logo &&
         !_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('text.please_upload_logo')
                  }, null, 8, _hoisted_8),
                  _hoisted_9
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.applicationForm.id)
              ? (_openBlock(), _createBlock(_component_FormRenderComponent, {
                  key: 1,
                  "form-object": _ctx.applicationForm,
                  "empty-optionlabel": _ctx.$t('text.select_empty'),
                  onSubmitted: _ctx.handleSubmit,
                  onChanged: _ctx.updateState,
                  ref: "form",
                  isReadOnly: _ctx.applicationInReadonlyMode(_ctx.application, _ctx.currentApplicationPeriod)
                }, {
                  default: _withCtx(() => [
                    (_ctx.applicationForm.form_type === _ctx.FormType.FormTypeBasicUnderstanding)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_10,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('text.appendix')), 1),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('text.application_form_files_subtitle')), 1),
                          (_ctx.applicationFormFiles.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("table", _hoisted_13, [
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationFormFiles, (file) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: file.id
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("a", {
                                            href: file.uploaded_file,
                                            target: "_blank"
                                          }, _toDisplayString(file.name), 9, _hoisted_14)
                                        ]),
                                        _createElementVNode("td", _hoisted_15, [
                                          (!_ctx.formIsReadOnly())
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: "",
                                                onClick: _withModifiers(($event: any) => (_ctx.deleteApplicationFormFile(file.id)), ["prevent"])
                                              }, _toDisplayString(_ctx.$t('text.delete')), 9, _hoisted_16))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.applicationFormFiles.length < 5 && !_ctx.formIsReadOnly())
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-primary",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showApplicationFormFileUploadForm && _ctx.showApplicationFormFileUploadForm(...args)), ["prevent"])),
                                type: "button"
                              }, _toDisplayString(_ctx.$t('actions.add_file')), 1))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                "data-bs-toggle": "tooltip",
                                title: _ctx.$t('text.enough_attachments')
                              }, [
                                _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.$t('actions.add_file')), 1)
                              ], 8, _hoisted_17))
                        ], 64))
                      : _createCommentVNode("", true),
                    (!_ctx.formIsReadOnly())
                      ? (_openBlock(), _createBlock(_component_MainFormBottomBar, { key: 1 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("button", _hoisted_21, _toDisplayString(_ctx.$t('text.intermediate_save')), 1)
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("button", {
                                  class: "btn btn-outline-primary",
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleFinish()), ["prevent"]))
                                }, _toDisplayString(_ctx.$t('text.finish')), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["form-object", "empty-optionlabel", "onSubmitted", "onChanged", "isReadOnly"]))
              : _createCommentVNode("", true)
          ]),
          "form-progress": _withCtx(() => [
            (_ctx.showErrors)
              ? (_openBlock(), _createBlock(_component_ProgressWheel, {
                  state: _ctx.currentFormState,
                  key: _ctx.currentFormState,
                  class: "sticky-below-page-form-nav"
                }, null, 8, ["state"]))
              : (_openBlock(), _createBlock(_component_ProgressWheel, {
                  key: 1,
                  state: _ctx.getStateOfApplicationForm(_ctx.applicationForm, _ctx.application.organization, _ctx.applicationFormFiles.length),
                  class: "sticky-below-page-form-nav"
                }, null, 8, ["state"])),
            (_ctx.isLoaded && _ctx.isStatisticalFormOfScienceOrganization(_ctx.applicationForm, _ctx.application.organization))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('text.excel_file_explanation')), 1),
                    _createElementVNode("a", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_b_icon_file_earmark_arrow_down),
                          _createTextVNode(_toDisplayString(_ctx.$t('text.download_excel_file')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('text.stat_upload_header')), 1),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('text.stat_upload_description')), 1),
                      _hoisted_32,
                      (_ctx.applicationFormFiles.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("table", _hoisted_34, [
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationFormFiles, (file) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: file.id
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("a", {
                                        href: file.uploaded_file,
                                        target: "_blank"
                                      }, _toDisplayString(file.name), 9, _hoisted_35)
                                    ]),
                                    _createElementVNode("td", _hoisted_36, [
                                      (!_ctx.formIsReadOnly())
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: "",
                                            onClick: _withModifiers(($event: any) => (_ctx.deleteApplicationFormFile(file.id)), ["prevent"])
                                          }, _toDisplayString(_ctx.$t('text.delete')), 9, _hoisted_37))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.applicationFormFiles.length === 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-primary mt-2",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showApplicationFormFileUploadForm && _ctx.showApplicationFormFileUploadForm(...args)), ["prevent"])),
                            type: "button"
                          }, _toDisplayString(_ctx.$t('text.filled_form_upload')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_ApplicationFormFileUpload, {
              ref: "applicationFormFileUpload",
              "size-class": "modal-lg",
              "application-form-id": _ctx.applicationForm.id,
              onFileUploaded: _ctx.reloadFiles
            }, null, 8, ["application-form-id", "onFileUploaded"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}